import { createSelector } from 'reselect';

import { getOneXpExperiments } from 'src/universal/redux/oneXp';
import { getExperimentalPageData } from 'src/universal/redux/page';

export const getG166 = createSelector(
  [getOneXpExperiments, getExperimentalPageData],
  (oneXpExperiments, pageData) => {
    const experiment =
      oneXpExperiments['GCS-166-Testimonial-Cards']?.dimensions[0]?.variant;

    const variants = {
      isControl: false,
      isBlue: false,
      isGray: false
    };

    let color = '';

    if (experiment === 'control') {
      variants.isControl = true;
    } else if (experiment === 'Blue Background') {
      variants.isBlue = true;
      color = 'blue';
    } else if (experiment === 'Gray Background') {
      variants.isGray = true;
      color = 'gray';
    }

    const { GCS166 } = pageData;
    GCS166.color = color;

    return {
      active: !(experiment === undefined),
      variants,
      data: GCS166
    };
  }
);
